module.exports = __webpack_public_path__ + "static/media/future-1.857ed55d.jpg";